import { render } from "./NavigationElement.vue?vue&type=template&id=fae94616"
import script from "./NavigationElement.vue?vue&type=script&lang=js"
export * from "./NavigationElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__